export const GET_FACEBOOK = "GET_FACEBOOK";
export const GET_FACEBOOK_SUCCESS = "GET_FACEBOOK_SUCCESS";
export const GET_FACEBOOK_FAIL = "GET_FACEBOOK_FAIL";

export const ADD_FACEBOOK_SUCCESS = "ADD_FACEBOOK_SUCCESS";
export const ADD_FACEBOOK_FAIL = "ADD_FACEBOOK_FAIL";
export const UPDATE_FACEBOOK_SUCCESS = "UPDATE_FACEBOOK_SUCCESS";
export const DELETE_FACEBOOK_SUCCESS = "DELETE_FACEBOOK_SUCCESS";
